const translation = {
  daysInWeek: {
    Sat: 'Sat',
    Fri: 'Libre',
    Wed: 'Mercredi',
    Mon: 'Mon',
    Thu: 'Jeudi',
    Tue: 'Mardi',
    Sun: 'Soleil',
  },
  months: {
    October: 'octobre',
    July: 'Juillet',
    June: 'Juin',
    December: 'Décembre',
    November: 'Novembre',
    April: 'Avril',
    September: 'Septembre',
    February: 'Février',
    May: 'Mai',
    January: 'Janvier',
    August: 'août',
    March: 'Mars',
  },
  operation: {
    now: 'Maintenant',
    pickDate: 'Choisir une date',
    cancel: 'Annuler',
    ok: 'D\'accord',
  },
  title: {
    pickTime: 'Choisir le temps',
  },
  defaultPlaceholder: 'Choisissez un moment...',
}

export default translation
